import React from "react";

const ProgressBar = ({ processed = 0, total = 0 }) => {
    const percent = total > 0 ? Math.min((processed / total) * 100, 100) : 0;

    const containerStyle = {
        width: "100%",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        overflow: "hidden",
        height: "2rem",
        position: "relative",
        marginBottom: "2rem",
    };

    const barStyle = {
        width: `${percent}%`,
        backgroundColor: "#43aae3",
        height: "100%",
        transition: "width 0.3s ease",
    };

    const labelStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        fontSize: "1.2rem",
        lineHeight: "1.2rem",
        color: "#000",
        fontWeight: "600",
    };

    return (
        <div style={containerStyle}>
            <div style={barStyle} />
            <div style={labelStyle}>
                {processed} / {total} ({Math.round(percent)}%)
            </div>
        </div>
    );
};

export default ProgressBar;
